export const ROUTE_PATHS = {
    // Base paths
    APP: '/app',
    AUTH: '/app/auth',
    INDEX: ''
};

export const VERIFICATION_ROUTES = {
    VERIFY_EMAIL: 'verify-email',
    VALIDATE_ACCOUNT: 'validate-account',
};

// Special route path checks
export const isVerificationRoute = (path: string): boolean =>
    path === VERIFICATION_ROUTES.VERIFY_EMAIL || path === VERIFICATION_ROUTES.VALIDATE_ACCOUNT;

export const isIndexRoute = (path: string): boolean =>
    path === ROUTE_PATHS.INDEX;